/**
 * Grille des recettes trouvées
 */

import React from "react";
import { motion } from "framer-motion";
import { HiOutlineSparkles } from "react-icons/hi2";
import FridgeRecipeCard from "./FridgeRecipeCard.jsx";

export default function RecipeResultsGrid({
  matchingRecipes,
  setSelectedRecipe,
  t,
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <h2 className="text-lg font-bold text-ink-900 dark:text-white mb-4 flex items-center gap-2">
        <HiOutlineSparkles className="w-5 h-5 text-orange-300" />
        {t("recipesFound")} ({matchingRecipes.length})
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
        {matchingRecipes.map((recipe) => (
          <FridgeRecipeCard
            key={recipe.id}
            recipe={recipe}
            onSelect={setSelectedRecipe}
            t={t}
          />
        ))}
      </div>
    </motion.div>
  );
}
